(function () {
  var STORAGE_PREFIX = 'gangoly_wa_channel_popup_last_shown_';

  function safeNumber(value, fallback) {
    var number = parseFloat(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function shouldShow(sectionId, frequencyHours) {
    try {
      var lastShown = parseInt(localStorage.getItem(STORAGE_PREFIX + sectionId) || '0', 10);
      if (!lastShown) return true;
      return Date.now() - lastShown > frequencyHours * 60 * 60 * 1000;
    } catch (error) {
      return true;
    }
  }

  function rememberShown(sectionId) {
    try {
      localStorage.setItem(STORAGE_PREFIX + sectionId, String(Date.now()));
    } catch (error) {
      // If storage is blocked, the popup can still work normally.
    }
  }

  function sendTracking(root, eventName) {
    var endpoint = root.getAttribute('data-tracking-endpoint');

    var payload = {
      event: eventName,
      source: 'whatsapp_channel_popup',
      section_id: root.getAttribute('data-section-id'),
      channel_url: root.getAttribute('data-channel-url'),
      path: window.location.pathname,
      page_title: document.title,
      timestamp: new Date().toISOString()
    };

    // Shopify analytics
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('gangoly:wa_channel_' + eventName, payload);
      }
    } catch (error) {}

    // Google Tag Manager
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'gangoly_wa_channel_' + eventName,
        wa_event: eventName,
        wa_channel_path: payload.path,
        wa_channel_section_id: payload.section_id
      });
    } catch (error) {}

    // Custom tracking endpoint (Google Apps Script or any server)
    if (!endpoint) return;

    try {
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        // text/plain avoids a CORS preflight — Google Apps Script accepts this
        navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain' }));
        return;
      }
      // no-cors mode skips preflight — response is opaque but event still lands
      fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        body: body
      }).catch(function () {});
    } catch (error) {}
  }

  function initPopup(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var sectionId       = root.getAttribute('data-section-id') || 'default';
    var delaySeconds    = safeNumber(root.getAttribute('data-delay'), 4);
    var frequencyHours  = safeNumber(root.getAttribute('data-frequency-hours'), 24);
    var closeButtons    = root.querySelectorAll('[data-wa-channel-close]');
    var joinButton      = root.querySelector('[data-wa-channel-join]');
    var alreadyButton   = root.querySelector('[data-wa-channel-already]');

    function openPopup() {
      if (!shouldShow(sectionId, frequencyHours)) return;
      root.hidden = false;
      rememberShown(sectionId);
      sendTracking(root, 'popup_shown'); // ← track impression
      document.documentElement.classList.add('wa-channel-popup-lock');
      requestAnimationFrame(function () {
        root.classList.add('is-open');
      });
    }

    function closePopup() {
      root.classList.remove('is-open');
      document.documentElement.classList.remove('wa-channel-popup-lock');
      window.setTimeout(function () { root.hidden = true; }, 260);
    }

    // ── Close / dismiss ──────────────────────────────────────────────────────
    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        sendTracking(root, 'dismiss'); // ← track dismiss (× or No Thanks)
        closePopup();
      });
    });

    // ── Join channel ─────────────────────────────────────────────────────────
    if (joinButton) {
      joinButton.addEventListener('click', function () {
        sendTracking(root, 'join_click'); // ← track join
      });
    }

    // ── Already a member ─────────────────────────────────────────────────────
    if (alreadyButton) {
      alreadyButton.addEventListener('click', function () {
        sendTracking(root, 'already_member'); // ← track already member
        closePopup();
      });
    }

    // ── Escape key ───────────────────────────────────────────────────────────
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !root.hidden) {
        sendTracking(root, 'dismiss');
        closePopup();
      }
    });

    if (document.readyState === 'complete') {
      window.setTimeout(openPopup, delaySeconds * 1000);
    } else {
      window.addEventListener('load', function () {
        window.setTimeout(openPopup, delaySeconds * 1000);
      }, { once: true });
    }
  }

  function initAllPopups() {
    document.querySelectorAll('[data-wa-channel-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPopups);
  } else {
    initAllPopups();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initPopup(event.target.querySelector('[data-wa-channel-popup]'));
  });
})();

